import React from "react"
import classnames from "classnames"
import { array, bool, func, object, oneOfType, string } from "prop-types"

import ThemeConsumer from "../ThemeConsumer"

import FloatLabelSelect from "../FloatLabelSelect"
import TypographTheme from "../../../components/Typograph"

import { maskCPFCPNJ } from "../../../services/utils/mask"

import { AUTOMATIC_DEBIT_BILLS_SELECT } from "shared/constants/idsElements"

function GeneralProductInformation({
  theme,
  icons,
  details,
  options,
  optionSelected,
  onChangeOption,
  hasSelectOption,
  titleSelectOption
}) {
  const containerDetails = classnames(theme.containerDetails, {
    [theme.customContainer]: details.activationDate
  })

  return (
    <section className={classnames(theme.container, theme.pa6)}>
      <TypographTheme
        htmlTag="h2"
        size="medium"
        color="charcoal_grey"
        classNames={theme.title}
      >
        <img src={icons.walletInformation.type} alt="Ícone de informações" />
        Informações gerais
      </TypographTheme>

      {hasSelectOption && (
        <div className={theme.selectOption}>
          <TypographTheme
            htmlTag="label"
            size="small"
            color="charcoal_grey"
            weight="bold"
            htmlFor={AUTOMATIC_DEBIT_BILLS_SELECT}
          >
            {titleSelectOption}
          </TypographTheme>
          <FloatLabelSelect
            id={AUTOMATIC_DEBIT_BILLS_SELECT}
            options={options}
            value={optionSelected}
            onChange={onChangeOption}
          />
        </div>
      )}

      <section className={containerDetails}>
        <section className={theme.p3}>
          <img src={icons.smartphone.type} alt="Ícone de telefone" />

          <div>
            <TypographTheme
              htmlTag="p"
              size="small"
              color="charcoal_grey"
              weight="bold"
              classNames={theme.detailsTitle}
            >
              Plano
            </TypographTheme>
            <TypographTheme
              htmlTag="p"
              size="small"
              color="charcoal_grey"
              weight="medium"
              classNames={theme.detailsDescription}
              title={details.products || "-"}
            >
              {details.products || "-"}
            </TypographTheme>
          </div>
        </section>

        <section className={theme.p3}>
          <img src={icons.document.type} alt="Ícone de documento" />

          <div>
            <TypographTheme
              htmlTag="p"
              size="small"
              color="charcoal_grey"
              weight="bold"
              classNames={theme.detailsTitle}
            >
              Contrato
            </TypographTheme>
            <TypographTheme
              htmlTag="p"
              size="small"
              color="charcoal_grey"
              weight="medium"
              classNames={theme.detailsDescription}
            >
              {details.agreementId || "-"}
            </TypographTheme>
          </div>
        </section>

        {details.activationDate && (
          <section className={theme.p3}>
            <img src={icons.activation.type} alt="Ícone de ativação" />
            <div>
              <div>
                <TypographTheme
                  htmlTag="p"
                  size="small"
                  color="charcoal_grey"
                  weight="bold"
                  classNames={theme.detailsTitle}
                >
                  Ativação
                </TypographTheme>
                <TypographTheme
                  htmlTag="p"
                  size="small"
                  color="charcoal_grey"
                  weight="medium"
                  classNames={theme.detailsDescription}
                >
                  {details.activationDate}
                </TypographTheme>
              </div>
            </div>
          </section>
        )}

        <section className={theme.p3}>
          <img src={icons.folder.type} alt="Ícone de pasta" />
          <div>
            <TypographTheme
              htmlTag="p"
              size="small"
              color="charcoal_grey"
              weight="bold"
              classNames={theme.detailsTitle}
            >
              CPF/CNPJ
            </TypographTheme>
            <TypographTheme
              htmlTag="p"
              size="small"
              color="charcoal_grey"
              weight="medium"
              classNames={theme.detailsDescription}
            >
              {maskCPFCPNJ(details.documentNumber || "")}
            </TypographTheme>
          </div>
        </section>

        {details.finalDayToPay && (
          <section className={theme.p3}>
            <img src={icons.calendar.type} alt="Ícone de calendário" />

            <div>
              <TypographTheme
                htmlTag="p"
                size="small"
                color="charcoal_grey"
                weight="bold"
                classNames={theme.detailsTitle}
              >
                Vencimento
              </TypographTheme>
              <TypographTheme
                htmlTag="p"
                size="small"
                color="charcoal_grey"
                weight="medium"
                classNames={theme.detailsDescription}
              >
                Todo dia {details.finalDayToPay || ""}
              </TypographTheme>
            </div>
          </section>
        )}
      </section>
    </section>
  )
}

GeneralProductInformation.propTypes = {
  theme: object,
  icons: object,
  details: object,
  options: array,
  optionSelected: oneOfType([object, string]),
  onChangeOption: func,
  hasSelectOption: bool,
  titleSelectOption: string,
  isDataQuota: bool
}

GeneralProductInformation.defaultProps = {
  titleSelectOption: "Selecione a conta de faturamento",
  isDataQuota: false
}

export default ThemeConsumer("UIGeneralProductInformation")(
  GeneralProductInformation
)



// WEBPACK FOOTER //
// ./src/shared/components/GeneralProductInformation/index.js